import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

export default function BabyTeethingSection ({groupData, eleRef}){
    return(
        <section className="groups-section">
            <div className="section-title">Groups</div>
            <div className="groups-main">
                {/* <div className="groups-block"> */}
                {groupData.groups && groupData.groups.map((group, id) => 
                <div key={id} className="common-sect">
                    <div className="left arti-image">
                        <a href={`https://parenting.firstcry.com/groups/${service.genquestionurl(group.categoryName)}/${service.genquestionurl(group.groupTitle)}-${group.groupId}`}>
                        <img src={group.groupImage.replace("http://", "https://")} id="dev_grp_img"/>
                        </a>
                    </div>
                    <div className="left arti-details">
                        <div className="M15_42 common-title"><a className="M15_42" href={`https://parenting.firstcry.com/groups/${service.genquestionurl(group.categoryName)}/${service.genquestionurl(group.groupTitle)}-${group.groupId}`} id="dev_grp_title">{group.groupTitle}</a></div>
                        <div className="R14_75 common-desc line-clamp">
                            {group.groupDescription}
                        </div>
                        <div className="arti-actions">
                            <div className="left view-action" id="grpcomments">
                                <a href={`https://parenting.firstcry.com/groups/${service.genquestionurl(group.categoryName)}/${service.genquestionurl(group.groupTitle)}-${group.groupId}`}>
                                    <span data-icon-font="e" className="left"></span>
                                </a>
                                <span className="action-text left">{group.comments_count}</span>
                            </div>
                            <div className="view-action" id="grpmembers">
                                {/* <span data-icon-font="T" className="left"></span> */}
                                <span className="action-text">{group.group_members} Members</span>
                            </div>
                            {group.isJoined ?
                            <div className="right join-btn joined">Joined</div>
                            :
                            <div className="right join-btn" onClick={() => actions.joinGroup(group.groupId, group.categoryId)}>Join</div>
                            }
                        </div>
                    </div>
                </div>
                )}
                {/* </div> */}
            </div>
            {groupData.search_cnt > groupData.groups.length &&
            <div className="moreResults dev_v_all" title="Groups" onClick={()=>eleRef.getMoreSearchData(groupData.type)}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
